export default __webpack_public_path__ + "static/media/remote_interview.ea75a723.svg";